import { useCallback, useState } from 'react';

import { UpdateInboxEntryInput } from '@this+that/models';
import log from 'loglevel';

import { useUpdateInboxEntry } from './useUpdateInboxEntry';
import { useInboxEntriesStore } from '../../store';
import { pushGTMEvent } from '../../utils/analytics/gtm';

export const useMarkInboxEntryAsUnresolved = () => {
  const { handleUpdateInboxEntry } = useUpdateInboxEntry();
  const [isUnresolving, setIsUnresolving] = useState(false);

  const markAsUnresolved = useCallback(
    async (inboxEntryId: string): Promise<boolean> => {
      setIsUnresolving(true);
      try {
        const updateData: UpdateInboxEntryInput = {
          id: inboxEntryId,
          resolvedAt: null,
        };

        const updatedEntry = await handleUpdateInboxEntry(updateData);

        if (updatedEntry) {
          pushGTMEvent({ event: 'dobox_unresolved' });
          useInboxEntriesStore
            .getState()
            .taskManager.activeTaskGroup.saveDetailedInboxEntry(updatedEntry);
          log.info(`Inbox entry ${inboxEntryId} marked as unresolved`);
          return true;
        }

        return false;
      } catch (error) {
        log.error('Error marking inbox entry as unresolved:', error);
        return false;
      } finally {
        setIsUnresolving(false);
      }
    },
    [handleUpdateInboxEntry],
  );

  return {
    markAsUnresolved,
    isUnresolving,
  };
};
